<!-- CO2 -->
<ac-container width="fill" height="fill" padding-horizontal="8" padding-vertical="8" gap-horizontal="8">
	<!-- Left Side Container -->
	<ac-container auto-layout="vertical" width="fill" height="fill" gap-vertical="8" flex-basis-zero="true">
		<!-- Components CO2 Container -->
		<ac-stroke-container auto-layout="vertical" width="fill" height="fill" gap-vertical="12">
			<!-- Topbar Container -->
			<ac-container width="fill" alignment="center" gap-horizontal="auto">
				<!-- Icon Header Container -->
				<ac-container alignment="center" gap-horizontal="8">
					<ac-icon name="speedometer-04"></ac-icon>
					<ac-label [text]="'masterdata.co2.data_sets.co2_data_sets' | translate" variant="dark" size="large"></ac-label>
				</ac-container>
				<!-- Filter Input Field -->
				<ac-input-field
					(InputFieldEvent.changed)="controller.filterComponentCO2Controller.filterInputChanged($event)"
					[text]="model.filterComponentCO2Model.filterInputText"
					[enabled]="model.filterComponentCO2Model.filterInputEnabled"
					width="184"
					icon="filter-lines"
					[placeholder]="'masterdata.co2.data_sets.filter' | translate"></ac-input-field>
				<!-- Buttons Container -->
				<ac-container gap-horizontal="8">
					<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2Controller.showDialog()" [enabled]="model.deleteComponentCO2Model.deleteButtonEnabled" icon="trash-01" [text]="'masterdata.co2.data_sets.delete' | translate"></ac-button>
					<ac-button (ButtonEvent.clicked)="controller.createComponentCO2Controller.showDialog()" icon="plus" [text]="'masterdata.co2.data_sets.create' | translate"></ac-button>
					<ac-button (ButtonEvent.clicked)="controller.editComponentCO2Controller.showDialog()" [enabled]="model.editComponentCO2Model.editButtonEnabled" icon="edit-02" [text]="'masterdata.co2.data_sets.edit' | translate"></ac-button>
				</ac-container>
			</ac-container>
			<!-- Component CO2 List Container -->
			<ac-container auto-layout="vertical" width="fill" height="fill" gap-vertical="8">
				<!-- List Header -->
				<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
					<ac-check-box (CheckBoxEvent.selectedChanged)="controller.deleteComponentCO2Controller.selectAllComponentCO2CheckBoxChanged($event)" [enabled]="model.listComponentCO2Model.selectAllCheckBoxEnabled" [selected]="model.deleteComponentCO2Model.selectAllCheckBoxSelected"></ac-check-box>
					<ac-label [text]="'masterdata.co2.key' | translate" variant="light" width="128"></ac-label>
					<ac-label [text]="'masterdata.co2.epd' | translate" variant="light" width="128"></ac-label>
					<ac-label [text]="'masterdata.co2.description' | translate" variant="light" width="fill"></ac-label>
					<ac-label [text]="'masterdata.co2.data_sets.edited_by' | translate" variant="light" width="128"></ac-label>
					<ac-label text-align-horizontal="right" [text]="'masterdata.co2.data_sets.updated' | translate" variant="light" width="96"></ac-label>
				</ac-container>
				<!-- Component CO2 List -->
				<ac-component-co2-list
					(CheckBoxEvent.selectedChanged)="controller.deleteComponentCO2Controller.deleteCheckBoxToogle($event)"
					(SelectListEvent.selectionChanged)="controller.selectedComponentCO2Changed($event)"
					[data]="model.listComponentCO2Model.co2Collection"
					[selectedItem]="model.listComponentCO2Model.firstSelectedItem"></ac-component-co2-list>
			</ac-container>
		</ac-stroke-container>
		<!-- Phases CO2 Container -->
		<ac-stroke-container auto-layout="vertical" width="fill" gap-vertical="12">
			<!-- Topbar Container -->
			<ac-container width="fill">
				<!-- Icon Header Container -->
				<ac-container alignment="center" gap-horizontal="8" height="24">
					<ac-icon name="speedometer-01"></ac-icon>
					<ac-label [text]="model.phasesCO2Model.name" variant="dark" size="large"></ac-label>
				</ac-container>
			</ac-container>
			<!-- Bottom Container -->
			<ac-container auto-layout="vertical" width="fill" height="fill" gap-vertical="16">
				<!-- EPD, Name and Description row -->
				<ac-container width="fill" gap-horizontal="16">
					<!-- EPD -->
					<ac-form-input width="fill" [label]="'masterdata.co2.key' | translate" [text]="model.phasesCO2Model.name" readonly="true"></ac-form-input>
					<!-- Name -->
					<ac-form-input width="fill" [label]="'masterdata.co2.epd' | translate" [text]="model.phasesCO2Model.epd" readonly="true"></ac-form-input>
					<!-- Description -->
					<ac-form-input width="fill" [label]="'masterdata.co2.description' | translate" [text]="model.phasesCO2Model.description" readonly="true"></ac-form-input>
				</ac-container>
				<!-- A1, A2, A3, A4 and A5 -->
				<ac-container width="fill" gap-horizontal="16">
					<!-- A1 -->
					<ac-form-input width="fill" label="A1" [text]="model.phasesCO2Model.a1" text-align="right" readonly="true"></ac-form-input>
					<!-- A2 -->
					<ac-form-input width="fill" label="A2" [text]="model.phasesCO2Model.a2" text-align="right" readonly="true"></ac-form-input>
					<!-- A3 -->
					<ac-form-input width="fill" label="A3" [text]="model.phasesCO2Model.a3" text-align="right" readonly="true"></ac-form-input>
					<!-- A4 -->
					<ac-form-input width="fill" label="A4" [text]="model.phasesCO2Model.a4" text-align="right" readonly="true"></ac-form-input>
					<!-- A5 -->
					<ac-form-input width="fill" label="A5" [text]="model.phasesCO2Model.a5" text-align="right" readonly="true"></ac-form-input>
				</ac-container>
				<!-- C1, C2, C3, C4 and D -->
				<ac-container width="fill" gap-horizontal="16">
					<!-- C1 -->
					<ac-form-input width="fill" label="C1" [text]="model.phasesCO2Model.c1" text-align="right" readonly="true"></ac-form-input>
					<!-- C2 -->
					<ac-form-input width="fill" label="C2" [text]="model.phasesCO2Model.c2" text-align="right" readonly="true"></ac-form-input>
					<!-- C3 -->
					<ac-form-input width="fill" label="C3" [text]="model.phasesCO2Model.c3" text-align="right" readonly="true"></ac-form-input>
					<!-- C4 -->
					<ac-form-input width="fill" label="C4" [text]="model.phasesCO2Model.c4" text-align="right" readonly="true"></ac-form-input>
					<!-- D -->
					<ac-form-input width="fill" label="D" [text]="model.phasesCO2Model.d" text-align="right" readonly="true"></ac-form-input>
				</ac-container>
			</ac-container>
			<!-- MND Label -->
			<ac-label [text]="'masterdata.co2.phases.mnd' | translate"></ac-label>
		</ac-stroke-container>
	</ac-container>
	<!-- Right Side Container -->
	<ac-container auto-layout="vertical" width="fill" height="fill" gap-vertical="8" flex-basis-zero="true">
		<!-- Profile Sets Container -->
		<ac-stroke-container auto-layout="vertical" width="fill" height="fill" gap-vertical="12">
			<!-- Topbar Container -->
			<ac-container width="fill" alignment="center" gap-horizontal="auto">
				<!-- Icon Header Container -->
				<ac-container alignment="center" gap-horizontal="8">
					<ac-icon name="skew"></ac-icon>
					<ac-label [text]="'masterdata.co2.profile_sets.profile_sets' | translate" variant="dark" size="large"></ac-label>
					<ac-spinner width="20" height="20" spin="true" [visible]="model.listComponentCO2LinkModel.batchSpinnerVisible"></ac-spinner>
				</ac-container>
				<!-- Filter Input Field -->
				<ac-input-field
					(InputFieldEvent.changed)="controller.filterComponentCO2LinkController.filterInputChanged($event)"
					[text]="model.filterComponentCO2LinkModel.filterInputText"
					[enabled]="model.filterComponentCO2LinkModel.filterInputEnabled"
					width="184"
					icon="filter-lines"
					[placeholder]="'masterdata.co2.profile_sets.filter' | translate"></ac-input-field>
				<!-- Buttons Container -->
				<ac-container gap-horizontal="8">
					<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2LinkController.showDialog()" icon="trash-01" [text]="'masterdata.co2.profile_sets.delete' | translate" [enabled]="model.deleteComponentCO2LinkModel.deleteButtonEnabled"></ac-button>
					<ac-button (ButtonEvent.clicked)="controller.createComponentCO2LinkController.showDialog()" [enabled]="model.createComponentCO2LinkModel.createComponenCO2LinkButtonEnabled" icon="plus" [text]="'masterdata.co2.add' | translate"></ac-button>
					<ac-button (ButtonEvent.clicked)="controller.searchCO2LinkController.showDialog()" icon="search-md" [text]="'masterdata.co2.search' | translate"></ac-button>
				</ac-container>
			</ac-container>
			<!-- List Header -->
			<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
				<ac-check-box (CheckBoxEvent.selectedChanged)="controller.deleteComponentCO2LinkController.selectAllComponentCO2CheckBoxChanged($event)" [enabled]="model.listComponentCO2LinkModel.selectAllCheckBoxEnabled" [selected]="model.deleteComponentCO2LinkModel.selectAllCheckBoxSelected"></ac-check-box>
				<ac-label [text]="'masterdata.co2.name' | translate" variant="light" width="fill"></ac-label>
				<ac-label [text]="'masterdata.co2.description' | translate" variant="light" width="128"></ac-label>
			</ac-container>
			<ac-container width="fill" height="fill">
				<ac-component-co2-link-list (CheckBoxEvent.selectedChanged)="controller.deleteComponentCO2LinkController.deleteCheckBoxToogle($event)" [data]="model.listComponentCO2LinkModel.co2LinkCollection"></ac-component-co2-link-list>
				<ac-spinner-overlay [visible]="model.listComponentCO2LinkModel.loadingSpinnerVisible"></ac-spinner-overlay>
			</ac-container>
		</ac-stroke-container>
		<!-- Batch Upload / Download Container -->
		<ac-stroke-container alignment="top_center" auto-layout="vertical" width="fill" height="348" gap-vertical="12">
			<!-- Topbar Container -->
			<ac-container width="fill">
				<!-- Icon Header Container -->
				<ac-container alignment="center" gap-horizontal="8" height="24">
					<ac-icon name="upload-cloud-01"></ac-icon>
					<ac-label [text]="'masterdata.co2.batch.title' | translate" variant="dark" size="large"></ac-label>
				</ac-container>
			</ac-container>
			<!-- File Drop Picker -->
			<ac-file-drop-picker
				(FileDropPickerEvent.fileSelected)="controller.importCSVController.fileSelected($event)"
				[visible]="model.importCSVModel.fileDropPickerVisible"
				extension="CSV"
				[heading]="'masterdata.co2.batch.heading' | translate"
				[description]="'masterdata.co2.batch.description' | translate"
				mime-type="text/csv"
				width="fill"
				height="fill"></ac-file-drop-picker>
			<ac-label [text]="'masterdata.co2.batch.note' | translate"></ac-label>
			<ac-button (ButtonEvent.clicked)="controller.importCSVController.downloadCSVButtonClicked()" [enabled]="model.importCSVModel.downloadCSVButtonEnabled" icon="file-download-03" [text]="'masterdata.co2.batch.download' | translate" [visible]="model.importCSVModel.exportButtonVisible"></ac-button>
		</ac-stroke-container>
	</ac-container>
	<ac-spinner-overlay [visible]="model.listComponentCO2Model.globalSpinnerVisible"></ac-spinner-overlay>
</ac-container>

<!-- Create new ComponentCO2 Dialog -->
<dialog #createComponentCO2Dialog closedby="none" (FormInputEvent.notValidValueChanged)="controller.createComponentCO2Controller.formInputEvent($event)" (FormInputEvent.validValueChanged)="controller.createComponentCO2Controller.formInputEvent($event)">
	<ac-stroke-container width="600" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="plus"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.create_component_co2_dialog.label' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container auto-layout="vertical" width="fill" padding-horizontal="16" padding-vertical="16">
			<!-- Key and EPD row -->
			<ac-container width="fill" gap-horizontal="16">
				<!-- Key -->
				<ac-form-input
					width="fill"
					maximum-characters="55"
					[text]="model.createComponentCO2Model.name"
					[label]="'masterdata.co2.key' | translate"
					key="name"
					[required]="true"
					[requiredErrorMessage]="'masterdata.co2.errors.key_required' | translate"
					[regExp]="model.namePattern"
					[validationErrorMessage]="'masterdata.co2.errors.url_safe_format' | translate"></ac-form-input>
				<!-- EPD -->
				<ac-form-input width="fill" maximum-characters="55" [text]="model.createComponentCO2Model.epd" [label]="'masterdata.co2.epd' | translate" key="epd" [required]="true" [requiredErrorMessage]="'masterdata.co2.errors.epd_required' | translate"></ac-form-input>
			</ac-container>
			<!-- Conflict Error Message Label -->
			<ac-container width="fill" padding-vertical="8" [visible]="model.createComponentCO2Model.conflictErrorLabelVisible">
				<ac-label width="fill" variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.create_component_co2_dialog.errors.conflict' | translate"></ac-label>
			</ac-container>
			<!-- Description -->
			<ac-form-input width="fill" maximum-characters="55" [text]="model.createComponentCO2Model.description" [label]="'masterdata.co2.description' | translate" key="description"></ac-form-input>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Phases -->
		<ac-container padding-horizontal="16" padding-vertical="16" width="fill" auto-layout="vertical">
			<ac-container gap-horizontal="16" width="fill">
				<!-- A1 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.a1"
					label="A1"
					text-align="right"
					key="a1"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
				<!-- A2 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.a2"
					label="A2"
					text-align="right"
					key="a2"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- A3 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.a3"
					label="A3"
					text-align="right"
					key="a3"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
				<!-- A4 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.a4"
					label="A4"
					text-align="right"
					key="a4"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- A5 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.a5"
					label="A5"
					text-align="right"
					key="a5"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
				<!-- C1 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.c1"
					label="C1"
					text-align="right"
					key="c1"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- C2 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.c2"
					label="C2"
					text-align="right"
					key="c2"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
				<!-- C3 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.c3"
					label="C3"
					text-align="right"
					key="c3"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- C4 -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.c4"
					label="C4"
					text-align="right"
					key="c4"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
				<!-- D -->
				<ac-form-input
					width="fill"
					[text]="model.createComponentCO2Model.d"
					label="D"
					text-align="right"
					key="d"
					[regExp]="model.phasesCO2Model.phasePattern"
					[validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"
					[placeholder]="'masterdata.co2.create_component_co2_dialog.scientific' | translate"></ac-form-input>
			</ac-container>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.createComponentCO2Model.networkErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.createComponentCO2Model.unknownErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.createComponentCO2Controller.closeDialog()" icon="x-close" [text]="'masterdata.co2.create_component_co2_dialog.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.createComponentCO2Controller.createButtonClicked()" icon="plus" [text]="'masterdata.co2.create_component_co2_dialog.create' | translate" [enabled]="model.createComponentCO2Model.createButtonEnabled"></ac-button>
		</ac-container>
		<ac-spinner-overlay [visible]="model.createComponentCO2Model.createSpinnerVisible"></ac-spinner-overlay>
	</ac-stroke-container>
</dialog>

<!-- Edit existing ComponentCO2 Dialog -->
<dialog #editComponentCO2Dialog closedby="none" (FormInputEvent.notValidValueChanged)="controller.editComponentCO2Controller.formInputEvent($event)" (FormInputEvent.validValueChanged)="controller.editComponentCO2Controller.formInputEvent($event)">
	<ac-stroke-container width="600" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="edit-02"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.edit_component_co2_dialog.label' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container auto-layout="vertical" width="fill" padding-horizontal="16" padding-vertical="16">
			<!-- Key and EPD row -->
			<ac-container width="fill" gap-horizontal="16">
				<!-- Key -->
				<ac-form-input width="fill" maximum-characters="55" [text]="model.editComponentCO2Model.name" [label]="'masterdata.co2.key' | translate" [enabled]="false"></ac-form-input>
				<!-- EPD -->
				<ac-form-input width="fill" maximum-characters="55" [text]="model.editComponentCO2Model.epd" [label]="'masterdata.co2.epd' | translate" key="epd" [required]="true" [requiredErrorMessage]="'masterdata.co2.errors.epd_required' | translate"></ac-form-input>
			</ac-container>
			<!-- Description -->
			<ac-form-input width="fill" maximum-characters="55" [text]="model.editComponentCO2Model.description" [label]="'masterdata.co2.description' | translate" key="description"></ac-form-input>
		</ac-container>
		<!-- Phases -->
		<ac-container padding-horizontal="16" padding-vertical="16" width="fill" auto-layout="vertical">
			<ac-container gap-horizontal="16" width="fill">
				<!-- A1 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.a1" label="A1" text-align="right" key="a1" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
				<!-- A2 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.a2" label="A2" text-align="right" key="a2" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- A3 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.a3" label="A3" text-align="right" key="a3" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
				<!-- A4 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.a4" label="A4" text-align="right" key="a4" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- A5 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.a5" label="A5" text-align="right" key="a5" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
				<!-- C1 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.c1" label="C1" text-align="right" key="c1" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- C2 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.c2" label="C2" text-align="right" key="c2" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
				<!-- C3 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.c3" label="C3" text-align="right" key="c3" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
			</ac-container>
			<ac-container gap-horizontal="16" width="fill">
				<!-- C4 -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.c4" label="C4" text-align="right" key="c4" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
				<!-- D -->
				<ac-form-input width="fill" [text]="model.editComponentCO2Model.d" label="D" text-align="right" key="d" [regExp]="model.phasesCO2Model.phasePattern" [validationErrorMessage]="'masterdata.co2.errors.scientific_format' | translate"></ac-form-input>
			</ac-container>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.editComponentCO2Model.networkErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.editComponentCO2Model.unknownErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.editComponentCO2Controller.closeDialog()" icon="x-close" [text]="'masterdata.co2.create_component_co2_dialog.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.editComponentCO2Controller.updateButtonClicked()" icon="refresh-cw-04" [text]="'masterdata.co2.edit_component_co2_dialog.update' | translate" [enabled]="model.editComponentCO2Model.updateButtonEnabled"></ac-button>
		</ac-container>
		<ac-spinner-overlay [visible]="model.editComponentCO2Model.editSpinnerVisible"></ac-spinner-overlay>
	</ac-stroke-container>
</dialog>

<!-- Delete selected ComponentCO2 Dialog -->
<dialog #deleteComponentCO2Dialog closedby="none">
	<ac-stroke-container width="512" height="384" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="trash-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.delete_component_co2_dialog.label' | translate"></ac-label>
		</ac-container>
		<ac-divider></ac-divider>
		<ac-component height="16"></ac-component>
		<!-- List Header -->
		<ac-container width="fill" padding-horizontal="16">
			<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
				<ac-label [text]="'masterdata.co2.key' | translate" variant="light" width="128"></ac-label>
				<ac-label [text]="'masterdata.co2.description' | translate" variant="light" width="fill"></ac-label>
			</ac-container>
		</ac-container>
		<!-- Items to be deleted container -->
		<ac-container clip-content="true" height="fill" width="fill" auto-layout="vertical" padding-horizontal="32" padding-vertical="8">
			@for (item of model.deleteComponentCO2Model.itemsToBeDeleted.collection; track item) {
				<ac-container width="fill" height="32" alignment="left" gap-horizontal="16">
					<ac-label width="128" [text]="item.name"></ac-label>
					<ac-label width="fill" [text]="item.description"></ac-label>
				</ac-container>
			}
		</ac-container>
		<ac-container width="fill" alignment="center" padding-vertical="16" [visible]="model.deleteComponentCO2Model.deleteSpinnerVisible">
			<ac-spinner spin="true"></ac-spinner>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.deleteComponentCO2Model.networkErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.deleteComponentCO2Model.unknownErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2Controller.closeDialog()" [enabled]="model.deleteComponentCO2Model.dialogCancelButtonEnabled" icon="x-close" [text]="'masterdata.co2.delete_component_co2_dialog.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2Controller.dialogDeleteButtonClicked()" [enabled]="model.deleteComponentCO2Model.dialogDeleteButtonEnabled" icon="trash-01" [text]="'masterdata.co2.delete_component_co2_dialog.delete' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Create ComponentCO2LinkDialog -->
<dialog #createComponentCO2LinkDialog closedby="none" (FormInputEvent.notValidValueChanged)="controller.createComponentCO2LinkController.formInputEvent($event)" (FormInputEvent.validValueChanged)="controller.createComponentCO2LinkController.formInputEvent($event)">
	<ac-stroke-container width="384" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="plus"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.create_component_co2link_dialog.label' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container auto-layout="vertical" width="fill" padding-horizontal="16" padding-vertical="16">
			<!-- Key -->
			<ac-form-input
				width="fill"
				maximum-characters="55"
				[text]="model.createComponentCO2LinkModel.key"
				[label]="'masterdata.co2.create_component_co2link_dialog.key' | translate"
				key="key"
				[required]="true"
				[requiredErrorMessage]="'masterdata.co2.errors.key_required' | translate"
				[regExp]="model.namePattern"
				[validationErrorMessage]="'masterdata.co2.errors.url_safe_format' | translate"></ac-form-input>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.createComponentCO2LinkModel.networkErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.createComponentCO2LinkModel.unknownErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.createComponentCO2LinkController.closeDialog()" icon="x-close" [text]="'masterdata.co2.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.createComponentCO2LinkController.createButtonClicked()" icon="plus" [text]="'masterdata.co2.add' | translate" [enabled]="model.createComponentCO2LinkModel.createButtonEnabled"></ac-button>
		</ac-container>
		<ac-spinner-overlay [visible]="model.createComponentCO2LinkModel.createSpinnerVisible"></ac-spinner-overlay>
	</ac-stroke-container>
</dialog>

<!-- Delete selected ComponentCO2Link Dialog -->
<dialog #deleteComponentCO2LinkDialog closedby="none">
	<ac-stroke-container width="512" height="384" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="trash-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.delete_component_co2link_dialog.label' | translate"></ac-label>
		</ac-container>
		<ac-divider></ac-divider>
		<ac-component height="16"></ac-component>
		<!-- List Header -->
		<ac-container width="fill" padding-horizontal="16">
			<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
				<ac-label [text]="'masterdata.co2.key' | translate" variant="light" width="fill"></ac-label>
				<ac-label [text]="'masterdata.co2.description' | translate" variant="light" width="128"></ac-label>
			</ac-container>
		</ac-container>
		<!-- Items to be deleted container -->
		<ac-container clip-content="true" height="fill" width="fill" auto-layout="vertical" padding-horizontal="32" padding-vertical="8">
			@for (item of model.deleteComponentCO2LinkModel.itemsToBeDeleted.collection; track item) {
				<ac-container width="fill" height="32" alignment="left" gap-horizontal="16">
					<ac-label width="fill" [text]="item.name"></ac-label>
					<ac-label width="128" [text]="item.description"></ac-label>
				</ac-container>
			}
		</ac-container>
		<ac-container width="fill" alignment="center" padding-vertical="16" [visible]="model.deleteComponentCO2LinkModel.deleteSpinnerVisible">
			<ac-spinner spin="true"></ac-spinner>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="32" auto-layout="vertical" [visible]="model.deleteComponentCO2LinkModel.networkErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" auto-layout="vertical" [visible]="model.deleteComponentCO2LinkModel.unknownErrorLabelVisible">
			<ac-label variant="error" font-style="italic" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
			<ac-component height="16"></ac-component>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2LinkController.closeDialog()" [enabled]="model.deleteComponentCO2LinkModel.dialogCancelButtonEnabled" icon="x-close" [text]="'masterdata.co2.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.deleteComponentCO2LinkController.dialogDeleteButtonClicked()" [enabled]="model.deleteComponentCO2LinkModel.dialogDeleteButtonEnabled" icon="trash-01" [text]="'masterdata.co2.delete' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Global Error Dialog -->
<dialog #globalErrorDialog>
	<ac-stroke-container width="360" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="alert-circle"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.errors.network_title' | translate" [visible]="model.networkErrorLabelVisible"></ac-label>
			<ac-label variant="dark" [text]="'masterdata.co2.errors.unknown_title' | translate" [visible]="model.unknownErrorLabelVisible"></ac-label>
		</ac-container>
		<ac-divider></ac-divider>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.networkErrorLabelVisible">
			<ac-label variant="dark" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.unknownErrorLabelVisible">
			<ac-label variant="dark" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.closeGlobalErrorDialog()" icon="x-close" [text]="'masterdata.co2.ok' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Import CSV Dialog -->
<dialog #importCSVDialog closedby="none">
	<ac-stroke-container width="360" height="400" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="upload-cloud-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.batch.heading' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Invalid File Error Message Label -->
		<ac-container height="fill" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.importCSVModel.invalidFileErrrorMessageVisible">
			<ac-label variant="error" truncate="false" [text]="'masterdata.co2.errors.invalid_csv_file' | translate"></ac-label>
		</ac-container>
		<!-- Network Error Message Label -->
		<ac-container padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.importCSVModel.networkErrrorMessageVisible">
			<ac-label variant="error" truncate="false" [text]="'masterdata.co2.errors.network' | translate"></ac-label>
		</ac-container>
		<!-- Unknown Error Message Label -->
		<ac-container padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.importCSVModel.unknownErrrorMessageVisible">
			<ac-label variant="error" truncate="false" [text]="'masterdata.co2.errors.unknown' | translate"></ac-label>
		</ac-container>
		<!-- Import List -->
		<ac-import-component-co2link-list [data]="model.importCSVModel.importItems" [visible]="model.importCSVModel.importListVisible"></ac-import-component-co2link-list>
		<ac-container width="fill" alignment="center" padding-vertical="16" [visible]="model.importCSVModel.spinnerVisible">
			<ac-spinner spin="true"></ac-spinner>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.importCSVController.closeDialog()" [enabled]="model.importCSVModel.cancelButtonEnabled" icon="x-close" [text]="'masterdata.co2.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.importCSVController.dialogImportButtonClicked()" [enabled]="model.importCSVModel.importButtonEnabled" icon="upload-cloud-01" [text]="'masterdata.co2.batch.import' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<dialog #searchComponentCO2LinkDialog closedby="none">
	<ac-stroke-container width="512" height="574" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="skew"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'masterdata.co2.profile_sets.profile_sets' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Dialog Body -->
		<ac-container width="fill" height="fill" auto-layout="vertical" gap-vertical="12" padding-horizontal="16" padding-vertical="16">
			<!-- Search Input Field -->
			<ac-input-field (InputFieldEvent.changed)="controller.searchCO2LinkController.searchInputChanged($event)" width="fill" icon="search-md" [placeholder]="'masterdata.co2.search' | translate"></ac-input-field>
			<ac-container width="fill" height="fill" gap-vertical="8" auto-layout="vertical">
				<!-- Header -->
				<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
					<ac-label [text]="'masterdata.co2.profile_sets.profile_sets' | translate" variant="light" width="fill"></ac-label>
					<ac-label [text]="'masterdata.co2.epd' | translate" variant="light" width="fill"></ac-label>
				</ac-container>
				<!-- Search results list -->
				<ac-container width="fill" height="fill" padding-horizontal="16" auto-layout="vertical" clip-content="true">
					@for (link of model.searchCO2LinkModel.searchResults; track link) {
						<ac-container width="fill" height="32" alignment="left" gap-horizontal="16">
							<ac-label [text]="link.link" width="fill"></ac-label>
							<ac-label [text]="link.component" width="fill"></ac-label>
						</ac-container>
					}
					@if (model.searchCO2LinkModel.searchSpinnerVisible) {
						<ac-spinner-overlay></ac-spinner-overlay>
					}
				</ac-container>
			</ac-container>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="left" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="auto">
			<ac-label [text]="model.searchCO2LinkModel.searchLabelText" [variant]="model.searchCO2LinkModel.searchLabelVariant" width="fill" truncate="false"></ac-label>
			<ac-button (ButtonEvent.clicked)="controller.searchCO2LinkController.closeDialog()" icon="x-close" [text]="'masterdata.co2.close' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>
